import * as React from 'react';
import { Container } from "reactstrap";
import BotonExcelDefault from "./userButtonExcelDefault.tsx";
import { Box} from "@mui/material";

const AdmUsers = ({items}) => {

  const users = items

  return (  
    <Container className="pt-5">
      <Box>
        <BotonExcelDefault users={users} />
      </Box>
    </Container>
  );
};

export default AdmUsers;
